// extracted by mini-css-extract-plugin
export var selectVehicleForm = "selectedvehicle-module--selectVehicleForm--KHnFn";
export var selTitle = "selectedvehicle-module--selTitle--VmpPG";
export var selectCar = "selectedvehicle-module--selectCar--mLqa5";
export var error = "selectedvehicle-module--error--OHP1p";
export var selectedCar = "selectedvehicle-module--selectedCar--gEcgj";
export var chosen = "selectedvehicle-module--chosen--DhH7U";